import React from 'react';
import { number, node, string, func, bool } from 'prop-types';
import { Container, ImageBtn, Counter } from './numbered-button.styles';

const NumberedButton = ({
  children,
  amount = 0,
  nullable = true,
  truncateAmountThreshold,
  maxWidth = 60,
  maxHeight = 46,
  backgroundColor = '#ccc',
  counterColor = '#fff',
  fontColor = '#000',
  onClick
}) => {
  const greaterThanThreshold = () => truncateAmountThreshold && amount > truncateAmountThreshold;

  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(ImageBtn, {
    maxWidth,
    maxHeight,
    onClick
  }, children, (amount || nullable) && /*#__PURE__*/React.createElement(Counter, {
    "data-testid": "numbered-btn-counter",
    bg: counterColor,
    borderColor: backgroundColor,
    color: fontColor
  }, greaterThanThreshold() ? `${truncateAmountThreshold}+` : amount)));
};

process.env.NODE_ENV !== "production" ? NumberedButton.propTypes = {
  children: node,
  amount: number,
  nullable: bool,
  truncateAmountThreshold: number,
  backgroundColor: string,
  counterColor: string,
  fontColor: string,
  onClick: func,
  maxWidth: number,
  maxHeight: number
} : void 0;
export default NumberedButton;